import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from 'utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const couponApi = async (vendor) => {
  let url = '';
  const page = vendor?.page === 0 || vendor?.page ? vendor?.page + 1 : 1;
  if (vendor?.couponId) {
    url = `${env}${API_ENDPOINT.couponApi.getApi + '/' + vendor?.couponId}?isB2B=true`;
  } else {
    url = `${env}${API_ENDPOINT.couponApi.getApi + '?isB2B=true&location=' + (vendor?.location ? vendor?.location : '') + '&page=' + page + '&pageSize=' + (vendor?.pageSize ? vendor?.pageSize : '') + '&search=' + (vendor?.search ? vendor?.search : '')}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const addCouponApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.couponApi.addCoupon}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateCouponApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.couponApi.update + '/' + data.id}`, data.data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const deleteApi = async (data) => {
  let url = `${env}${API_ENDPOINT.couponApi.delete + '/' + data}?isB2B=true`;
  const res = await requestInstance.delete(url).catch((err) => err.response);
  return setCurrentUser(res);
};
